(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name RegistroController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('RegistroController', RegistroController);

    RegistroController.$inject = ["UserService",'$uibModal'];


    function RegistroController(UserService,$uibModal)
    {

    	var vm = this;
        vm.code = 0;
    	vm.msg = "";
        vm.loadingRec = false;
        vm.newPass = {pass1:"",pass2:"",hash:""};
        vm.msgRec = "";
        vm.countries=[];
        vm.loading = false;
        vm.recuperarDatos = {};
        UserService.getCountries().then(function(data){
            
            vm.countries = data.countries;
            
        });

    	vm.registro = {};
    	vm.registrarse = function(form){
            //console.log(form.reg_account_fiscal);
            
            //return false;
            if (!form.$valid) {
                angular.element("[name='" + form.$name + "']").find('.ng-invalid:visible:first').focus();
                return false;
            }
            vm.loading = true;
    		UserService.registrarUsuario(vm.registro,function(data){
                vm.code = data.code;
    			vm.msg = data.msg;
                vm.loading = false;
                if(data.code==-10){
                    angular.element("[name='" + form.$name + "']").find('#reg_email').focus();
                }
            });
    	};

        vm.cambiarPass = function(form){
            vm.loading = true;
            UserService.cambiarPass(vm.newPass,function(data){
                vm.code = data.code;
                vm.msg = data.msg;
                vm.loading = false;
            });
        };

    	
        vm.ibanEspacios = function(){
            //console.log("E");
            vm.registro.reg_account_fiscal = vm.registro.reg_account_fiscal.split(' ').join('');
        };
        

        vm.recuperarPass = function(){
            vm.loadingRec = true;
            UserService.recuperarPass(vm.recuperarDatos,function(data){
                if(data.code==1){
                    vm.recuperarDatos.mail = "";
                }
                vm.code = data.code;
                vm.msgRec = data.msg;
                vm.loadingRec = false;
            });
        };

        vm.recuperarPassByEmail = function(email){
            vm.loadingRec = true;
            vm.recuperarDatos.mail = email;
            UserService.recuperarPass(vm.recuperarDatos,function(data){
                if(data.code==1){
                    vm.recuperarDatos.mail = "";
                }
                vm.msgRec = data.msg;
                vm.loadingRec = false;
            });
        };

    }


})();